import {useHistory, useParams} from "react-router-dom";
import {useDifactoBucket} from "../../../components/utils";
import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import AudienceForm from "../../../components/data_products/audiences/AudienceForm";
import {
  useGetAudiencesQuery,
  useGetAudienceAggregationOptionsQuery,
  useUpdateAudienceMutation, useGetAudienceQuery
} from "../../../api/audienceApiSlice";
import {useControlledTabs} from "../../../components/Tabs";

function EditAudience(props) {
  const history = useHistory();
  const { audienceId } = useParams();
  const { data: audience, isSuccess } = useGetAudienceQuery(audienceId)
  const { t } = useTranslation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const [tabProps,] = useControlledTabs("audience", props)
  const bucket = useDifactoBucket();
  const { data: aggregationOptions = [] } = useGetAudienceAggregationOptionsQuery()
  const { data: audiences = [] } = useGetAudiencesQuery()

  const goToAudience = () => history.push({
    pathname: `/audiences/${audienceId}`,
    state: {activeTab: tabProps.active}
  })

  const [updateAudience] = useUpdateAudienceMutation()

  const submitProps = {
    handleSubmit: (data) => {
      updateAudience({...data, key: audienceId}).unwrap()
        .then(goToAudience)
        .catch(error => {})
    },
    errors: {}
  }

  if( !isSuccess ) { return (<></>) }
  return (
    <>
      <Title
        main={t("menu.audiences")}
        sub={audience.name}
        group={false}
        onBack={goToAudience}>
        <FormButton submit {...submitButtonProps}/>
        <FormButton cancel onClick={goToAudience} />
      </Title>
      <AudienceForm
        bucket={bucket}
        audience={audience}
        {...submitProps}
        setSubmitButtonProps={setSubmitButtonProps}
        audiences={audiences}
        aggregationOptions={aggregationOptions}
        tabProps={tabProps}/>
    </>
  )
}

export default EditAudience
